import {
  // Info,
  LucideIcon,
  Medal,
  ThumbsUp,
  Trophy,
  Book ,
} from 'lucide-react';

interface NavItem {
  label: string;
  href: string;
  icon?: LucideIcon | string;
}

export const navItems: NavItem[] = [
  {
    label: 'Cat DNA Tree',
    href: '/',
    icon: Medal,
  },
  {
    label: 'Docs',
    href: '/docs',
    icon: Book,
  },
  {
    label: 'Vote',
    href: '/vote',
    icon: ThumbsUp,
  },
  {
    label: 'DNA Archive',
    href: '/dna-archive',
    icon: Trophy,
  },
 
  // {
  //   label: "Logo",
  //   href: "/logo",
  //   icon: Codesandbox,
  // },
  // {
  //   label: 'About',
  //   href: '/about',
  //   icon: Info,
  // },
  // {
  //   label: "Instructions",
  //   href: "/instructions",
  //   icon: BookOpen,
  // },
  {
    label: 'Buy',
    href: '/buy',
    icon: '/assests/pump_buy_logo.png',
  },
];
